import _objectWithoutProperties from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';

var SceneComponent =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(SceneComponent, _React$PureComponent);

  function SceneComponent() {
    _classCallCheck(this, SceneComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(SceneComponent).apply(this, arguments));
  }

  _createClass(SceneComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          component = _this$props.component,
          rest = _objectWithoutProperties(_this$props, ["component"]);

      return React.createElement(component, rest);
    }
  }]);

  return SceneComponent;
}(React.PureComponent);

export default function SceneMap(scenes) {
  return function (_ref) {
    var route = _ref.route,
        jumpTo = _ref.jumpTo;
    return React.createElement(SceneComponent, {
      key: route.key,
      component: scenes[route.key],
      route: route,
      jumpTo: jumpTo
    });
  };
}